// IMPORT
    // MODULE(S)
        import React from 'react';
    // STYLE(S)
        import '../sass/Header.scss';



// MAIN CONTENT - FUNCTION / COMPONENT
    function Header() {


        // RETURN
            return (
                <div className="header App-section">
                    <h1><a href="./">TodoList</a></h1>
                    <h2>Your task(s) of the day</h2>
                    <p>Simple tool to increase your productivity</p>
                </div>
            )
    }
    export default Header;
